// Central config — change the WhatsApp number / links here and they update everywhere.
export const WHATSAPP_NUMBER = "918125761486"; // +91 81257 61486 (digits only, country code first)

export const waLink = (text) =>
    `https://wa.me/${WHATSAPP_NUMBER}${
        text ? `?text=${encodeURIComponent(text)}` : ""
    }`;

export const DEFAULT_WA_MSG =
    "Hello Analytrova! I'd like to discuss a project.";

export const CONTACT = {
    email: "info.analytrova@gmail.com",
    phoneDisplay: "+91 81257 61486",
    phoneHref: "tel:+918125761486",
    location: "Bengaluru, India",
    linkedin: "https://www.linkedin.com/in/analytrova-group-230976437/?isSelfProfile=true",
    instagram: "https://www.instagram.com/analytrova",
    youtube: "https://youtube.com/@analytrova?si=kGxh13AzaN0zPuqy",
    facebook: "https://www.facebook.com/profile.php?id=61595531813122",
};

export const NAV_LINKS = [
    { label: "Home", href: "#home" },
    { label: "About", href: "#about" },
    { label: "Services", href: "#services" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Why Us", href: "#why-us" },
    { label: "Contact", href: "#contact" },
];

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=85&w=1600&auto=format&fit=crop",
    about: "/about-laptop.jpg",
};
